// extracted by mini-css-extract-plugin
export default {"hint":"Hint__hint___3KauR"};